const medicineBazarPk = {
	search: {
		placeholders: [
			'دوائی کا نام لکھیں...',
			'جنیرک نام لکھیں...',
			'کمپنی کا نام لکھیں...',
			'برانڈ کا نام لکھیں...',
			'فارمیسی/اسٹور کا نام لکھیں...'
		]
	},
	sidebar: {
		categoriesTitle: 'کیٹیگریز',
		storesTitle: 'فارمیسیز'
	},
	upload: {
		title: 'نسخہ اپلوڈ کریں',
		subtitle: 'ڈاکٹر کا نسخہ اپلوڈ کریں اور آسانی سے ادویات آرڈر کریں',
		uploadedPrefix: '✓ فائل اپلوڈ ہو گئی:',
		chooseFile: 'فائل منتخب کریں',
		replaceFile: 'نئی فائل اپلوڈ کریں'
	},
	store: {
		serviceAreaLabel: 'سروس ایریا',
		nationwide: 'پورے ملک میں',
		medicineCountLabel: 'ادویات',
		close: 'بند کریں',
		productsOfSuffix: 'کی ادویات',
		descriptionPrefix: 'ذیل میں',
		descriptionSuffix: 'فارمیسی کی تمام دستیاب ادویات درج ہیں۔ آپ کیٹیگری کے لحاظ سے فلٹر کر سکتے ہیں۔'
	},
	card: {
		addToCart: 'بیگ میں شامل کریں'
	},
	empty: {
		title: 'کوئی دوا نہیں ملی',
		subtitle: 'براہ کرم دوسری کیٹیگری یا فارمیسی منتخب کریں'
	},
	prescriptionFlow: {
		successTitle: 'نسخہ کامیابی سے اپلوڈ ہو گیا!',
		instruction: 'براہ کرم ادویات کے آرڈر کے لیے درج ذیل تفصیلات بھریں',
		step1: {
			title: 'فارمیسی منتخب کریں',
			subtitle: 'کس فارمیسی سے خریدنا چاہیں گے؟',
			next: 'اگلا'
		},
		step2: {
			title: 'کورس کی مدت منتخب کریں',
			subtitle: 'کتنے دن کے لیے دوائیں چاہئیں؟',
			fullCourse: 'فل کورس',
			fiveDays: '۵ دن کے لیے',
			tenDays: '۱۰ دن کے لیے',
			customDays: 'حسبِ ضرورت دن',
			customDaysLabel: 'کتنے دن؟',
			customDaysPlaceholder: 'مثلاً: 15',
			back: 'واپس',
			next: 'اگلا'
		},
		step3: {
			title: 'آرڈر کی تصدیق کریں',
			summaryTitle: 'آپ کے آرڈر کا خلاصہ:',
			pharmacyLabel: 'فارمیسی',
			durationLabel: 'کورس کی مدت',
			prescriptionLabel: 'نسخہ',
			back: 'واپس',
			confirm: 'آرڈر کنفرم کریں'
		},
		snackbar: {
			successTitle: '🎉 آرڈر کامیابی سے جمع ہو گیا!',
			message: 'آپ کی منتخب کردہ فارمیسی جلد ہی قیمت اور تفصیل کے ساتھ رابطہ کرے گی۔'
		}
	}
};

export default medicineBazarPk;


